import { e as entry, X as XpBgImg, g as _createForOfIteratorHelper } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { n as normalizeComponent } from './normalize-component.js';

var script = {
  mixins: [entry],
  components: {
    XpBgImg: XpBgImg
  },
  computed: {
    isAllIconsEmpty: function isAllIconsEmpty() {
      return this.entryData.MenuItems.every(function (item) {
        return item.Icon.ID === 'xp-space';
      });
    }
  },
  mounted: function mounted() {
    this.$el.addEventListener('touchmove', function (event) {
      event.handled = true;
      /* Is handled by default scroll behavior of browser */
    }, false);
  },
  data: function data() {
    return {
      bNoThumbnails: this.entryData.Json && this.entryData.Json.ShowThumbnails ? !this.entryData.Json.ShowThumbnails : true,
      aMetaTagIcons: {
        stationen: 'xp-map-marker',
        dauer: 'xp-clock-o'
      },
      cType: this.entryData.Json && (this.entryData.Json.Type === 'branch' || this.entryData.Json.Type === 'list') ? 'list' : this.entryData.Json.Type
    };
  },
  methods: {
    getThumbnailWidth: function getThumbnailWidth() {
      var _iterator = _createForOfIteratorHelper(this.$xp.settings.mergedSettings.content.imageResolutions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var w = _step.value;

          if (this.cType === 'gallery' && w >= 400) {
            return w;
          } else if (this.cType !== 'gallery') {
            return w;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    // Text fuer Vorlesebrowser aufbereitet, damit nicht einzelne Elemente durchlaufen werden muessen. Doppelpunkte fuer Pausen.
    getReadout: function getReadout(item) {
      var cReadOutText = '';
      cReadOutText += item.Title;
      if (item.SubTitle > '') cReadOutText += ':' + item.SubTitle;
      cReadOutText += this.getMetaTagsReadout(item.MetaTags);
      return cReadOutText;
    },
    getMetaTagsReadout: function getMetaTagsReadout(aMetaTags) {
      var cReadOutText = '';

      for (var key in aMetaTags) {
        cReadOutText += ':' + key + ':' + aMetaTags[key];
      }

      return cReadOutText;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "js-entry o-entry c-menu-entry",
      class: _vm.cType,
      attrs: { role: "navigation" }
    },
    [
      _c(
        "ul",
        { staticClass: "c-menu-entry", attrs: { role: "list" } },
        _vm._l(this.entryData.MenuItems, function(item) {
          return _c(
            "li",
            {
              key: item.id,
              attrs: { role: "listitem", datasavefocus: "true" }
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "c-menu-entry__item",
                  class: { "no-thumbnails": _vm.bNoThumbnails },
                  attrs: { tag: "a", to: "/page/" + item.ID }
                },
                [
                  item.Icon.Type == "binary" && !_vm.bNoThumbnails
                    ? _c("xp-bg-img", {
                        staticClass: "c-menu-entry__item-imagewrapper",
                        class: item.Icon.Type,
                        attrs: {
                          tag: "div",
                          src: _vm.$xp.content.getImageUrl(
                            item.Icon.Image,
                            _vm.getThumbnailWidth()
                          ),
                          placeholderSrc: item.Icon.Image.Thumb
                        }
                      })
                    : item.Icon.Type == "icon" && item.Icon.ID !== "xp-space"
                    ? _c("span", {
                        staticClass: "xp",
                        class: item.Icon.ID,
                        attrs: { "aria-hidden": "true" }
                      })
                    : !_vm.isAllIconsEmpty
                    ? _c("span", {
                        staticClass: "xp xp--large xp-space",
                        attrs: { "aria-hidden": "true" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "c-menu-entry__item-textwrapper",
                      attrs: { "aria-label": _vm.getReadout(item) }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "c-menu-entry__item-text",
                          attrs: { "aria-hidden": "true" }
                        },
                        [_vm._v(_vm._s(item.Title))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "c-menu-entry__item-subtitle",
                          attrs: { "aria-hidden": "true" }
                        },
                        [_vm._v(_vm._s(item.SubTitle))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "c-menu-entry__item-metatags",
                          attrs: { "aria-hidden": "true" }
                        },
                        [
                          _vm._l(item.MetaTags, function(value, index) {
                            return [
                              _c("span", { key: "tag" + index }, [
                                _c("span", {
                                  staticClass: "xp",
                                  class: _vm.aMetaTagIcons[index]
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "c-menu-entry__item-metatag" },
                                  [_vm._v(_vm._s(value))]
                                )
                              ])
                            ]
                          })
                        ],
                        2
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        0
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=MenuEntry.js.map
